import { i18n } from './register/i18n'

export const useI18n = () => {
  return i18n
}